// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//           // ----added
//           nextArrow: this.querySelector('.arrow'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');

//         // ✅ FIX: Snapshot original backend media order on first load
//         this._originalMediaOrder = Array.from(
//           this.querySelector('[id^="Slider-Gallery"]')?.querySelectorAll('[data-media-id]') || []
//         ).map(el => el.dataset.mediaId);
//         this._originalThumbOrder = Array.from(
//           this.querySelector('[id^="Slider-Thumbnails"]')?.querySelectorAll('[data-target]') || []
//         ).map(el => el.dataset.target);
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click',this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//         // added
//         if (this.elements.nextArrow) {
//           this.elements.nextArrow.addEventListener('click', this.goToNextMedia.bind(this));
//         }
        

//       }

//       onSlideChanged(event) {
//         const thumbnail = this.elements.thumbnails.querySelector(
//           `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//         );
//         this.setActiveThumbnail(thumbnail);
//       }

//       setActiveMedia(mediaId, prepend) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         // if (prepend) {
//         //   activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

//         //   if (this.elements.thumbnails) {
//         //     const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         //     activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
//         //   }

//         //   if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         // }
//         if (prepend) {
//         const mediaList = activeMedia.parentElement;

//         // Batch all DOM moves in one fragment to prevent zoom listener re-attachment
//         const fragment = document.createDocumentFragment();
//         fragment.appendChild(activeMedia);
//         if (this._originalMediaOrder) {
//           this._originalMediaOrder
//             .filter(id => id !== mediaId)
//             .forEach(id => {
//               const el = mediaList.querySelector(`[data-media-id="${id}"]`);
//               if (el) fragment.appendChild(el);
//             });
//         }
//         mediaList.appendChild(fragment);

//         if (this.elements.thumbnails) {
//           const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//           const thumbList = activeThumbnail.parentElement;
//           const thumbFragment = document.createDocumentFragment();
//           thumbFragment.appendChild(activeThumbnail);
//           if (this._originalThumbOrder) {
//             this._originalThumbOrder
//               .filter(id => id !== mediaId)
//               .forEach(id => {
//                 const el = thumbList.querySelector(`[data-target="${id}"]`);
//                 if (el) thumbFragment.appendChild(el);
//               });
//           }
//           thumbList.appendChild(thumbFragment);
//         }

//         if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//       }

//         this.preventStickyHeader();
//         requestAnimationFrame(() => {
//            requestAnimationFrame(() => {

//             // window.setTimeout(() => {
//               // added
//               // FORCE layout calculation
//               // activeMedia.getBoundingClientRect();

//               if (!this.mql.matches || this.elements.thumbnails) {
//                 activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft,  behavior: 'smooth', });
//           }
//         })
//         //   const activeMediaRect = activeMedia.getBoundingClientRect();
//         //   // Don't scroll if the image is already in view
//         //   if (activeMediaRect.top > -0.5) return;
//         //   const top = activeMediaRect.top + window.scrollY;
//         //  // window.scrollTo({ top: top, behavior: 'smooth' });
//         });
   
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//         this.setActiveThumbnail(activeThumbnail);
//         this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//       }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails
//           .querySelectorAll('button')
//           .forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);
//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;
//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };
//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();
//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;
//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;
//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//       // added
//       // goToNextMedia() {
//       //     const mediaItems = this.elements.viewer.querySelectorAll('[data-media-id]');
//       //     if (!mediaItems.length) return;

//       //     const activeMedia = this.elements.viewer.querySelector('.is-active');
//       //     let nextMedia = mediaItems[0];

//       //     if (activeMedia) {
//       //       const index = Array.from(mediaItems).indexOf(activeMedia);
//       //       nextMedia = mediaItems[index + 1] || mediaItems[0];
//       //     }

//       //     this.setActiveMedia(nextMedia.dataset.mediaId, false);
//       //   }
//           goToNextMedia() {
//           const thumbnails = this.elements.thumbnails?.querySelectorAll('[data-target]');
//           if (!thumbnails || !thumbnails.length) return;

//           const activeMedia = this.elements.viewer.querySelector('.is-active');
//           if (!activeMedia) {
//             thumbnails[0].querySelector('button')?.click();
//             return;
//           }

//           const activeId = activeMedia.dataset.mediaId;

//           let nextIndex = 0;
//           thumbnails.forEach((thumb, index) => {
//             if (thumb.dataset.target === activeId) {
//               nextIndex = index + 1;
//             }
//           });

//           if (nextIndex >= thumbnails.length) nextIndex = 0;

//           thumbnails[nextIndex].querySelector('button')?.click();
//         }



//     }

//   );


// }
// ------------------stable version end ------------------------------------
// --------------------updated version start ----------------------------------

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          nextArrow: this.querySelector('.arrow'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // Snapshot original backend media order on first load
        this._originalMediaOrder = Array.from(
          this.querySelector('[id^="Slider-Gallery"]')?.querySelectorAll('[data-media-id]') || []
        ).map(el => el.dataset.mediaId);
        
        this._originalThumbOrder = Array.from(
          this.querySelector('[id^="Slider-Thumbnails"]')?.querySelectorAll('[data-target]') || []
        ).map(el => el.dataset.target);

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        
        if (this.elements.nextArrow) {
          this.elements.nextArrow.addEventListener('click', this.goToNextMedia.bind(this));
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      // setActiveMedia(mediaId, prepend) {
      //   const activeMedia =
      //     this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
      //     this.elements.viewer.querySelector('[data-media-id]');
        
      //   if (!activeMedia) return;

      //   // Set active class
      //   this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
      //     element.classList.remove('is-active');
      //   });
      //   activeMedia.classList.add('is-active');

      //   // --- NEW: Variant Filtering Logic ---
      //   // This runs when a variant is picked (prepend is true)
      //   if (prepend) {
      //     const variantId = activeMedia.getAttribute('data-variant-id'); // Ensure this attribute exists in Liquid
          
      //     if (variantId) {
      //       // Filter Main Viewer Media
      //       this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
      //         if (el.getAttribute('data-variant-id') === variantId || !el.getAttribute('data-variant-id')) {
      //           el.style.display = 'block';
      //           el.removeAttribute('aria-hidden');
      //         } else {
      //           el.style.display = 'none';
      //           el.setAttribute('aria-hidden', 'true');
      //         }
      //       });

      //       // Filter Thumbnails
      //       if (this.elements.thumbnails) {
      //         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((thumb) => {
      //           if (thumb.getAttribute('data-variant-id') === variantId || !thumb.getAttribute('data-variant-id')) {
      //             thumb.style.display = 'block';
      //             thumb.removeAttribute('aria-hidden');
      //           } else {
      //             thumb.style.display = 'none';
      //             thumb.setAttribute('aria-hidden', 'true');
      //           }
      //         });
      //       }
      //     }

      //     // Move active media to front and re-sort visible siblings
      //     const mediaList = activeMedia.parentElement;
      //     const fragment = document.createDocumentFragment();
      //     fragment.appendChild(activeMedia);

      //     if (this._originalMediaOrder) {
      //       this._originalMediaOrder
      //         .filter(id => id !== mediaId)
      //         .forEach(id => {
      //           const el = mediaList.querySelector(`[data-media-id="${id}"]`);
      //           // Only append if it's not hidden by the filter
      //           if (el && el.style.display !== 'none') fragment.appendChild(el);
      //         });
      //     }
      //     mediaList.appendChild(fragment);

      //     if (this.elements.thumbnails) {
      //       const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      //       const thumbList = activeThumbnail.parentElement;
      //       const thumbFragment = document.createDocumentFragment();
      //       thumbFragment.appendChild(activeThumbnail);
            
      //       if (this._originalThumbOrder) {
      //         this._originalThumbOrder
      //           .filter(id => id !== mediaId)
      //           .forEach(id => {
      //             const el = thumbList.querySelector(`[data-target="${id}"]`);
      //             if (el && el.style.display !== 'none') thumbFragment.appendChild(el);
      //           });
      //       }
      //       thumbList.appendChild(thumbFragment);
      //     }

      //     if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      //   }

      //   this.preventStickyHeader();
        
      //   requestAnimationFrame(() => {
      //     requestAnimationFrame(() => {
      //       if (!this.mql.matches || this.elements.thumbnails) {
      //         activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      //       }
      //     });
      //   });

      //   this.playActiveMedia(activeMedia);

      //   if (!this.elements.thumbnails) return;
      //   const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      //   this.setActiveThumbnail(activeThumbnail);
      //   if (activeThumbnail) {
      //      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      //   }
      // }
  setActiveMedia(mediaId, prepend) {
  const activeMedia =
    this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
    this.elements.viewer.querySelector('[data-media-id]');
  
  if (!activeMedia) return;

  // Reset ALL slides — clear any leftover display:none or aria-hidden
  this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
    el.style.display = '';
    el.removeAttribute('aria-hidden');
    el.classList.remove('is-active');
  });

  if (this.elements.thumbnails) {
    this.elements.thumbnails.querySelectorAll('[data-target]').forEach((el) => {
      el.style.display = '';
      el.removeAttribute('aria-hidden');
    });
  }

  activeMedia.classList.add('is-active');

  this.preventStickyHeader();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      // Reset slider pages so all slides are reachable
      if (this.elements.viewer.resetPages) this.elements.viewer.resetPages();
    });
  });

  this.playActiveMedia(activeMedia);

  if (!this.elements.thumbnails) return;
  const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
  this.setActiveThumbnail(activeThumbnail);
  if (activeThumbnail) {
    this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
  }
}
      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      goToNextMedia() {
        // Only target visible thumbnails
        const thumbnails = Array.from(this.elements.thumbnails?.querySelectorAll('[data-target]') || [])
          .filter(thumb => thumb.style.display !== 'none');
          
        if (!thumbnails.length) return;

        const activeMedia = this.elements.viewer.querySelector('.is-active');
        if (!activeMedia) {
          thumbnails[0].querySelector('button')?.click();
          return;
        }

        const activeId = activeMedia.dataset.mediaId;
        let nextIndex = 0;
        
        thumbnails.forEach((thumb, index) => {
          if (thumb.dataset.target === activeId) {
            nextIndex = index + 1;
          }
        });

        if (nextIndex >= thumbnails.length) nextIndex = 0;
        thumbnails[nextIndex].querySelector('button')?.click();
      }
    }
  );
}